import React from 'react'
import { useNavigate } from 'react-router-dom'

export function WelcomePage (): JSX.Element {
  const navigate = useNavigate()

  return (
    <div className="page-auth page-welcome container-fluid">
      <div className="content-row row">
        <h3 className="mb-5 text-center">Grant Classifier</h3>
        <button className="btn-confirm mb-3" onClick={() => { navigate('/login') }}>Log in</button>
        <button className="btn-register" onClick={() => { navigate('/register') }}>Register</button>
      </div>
    </div>
  )
}
